<template>
  <i class="item-show fa fa-map-marker" @click="onClick()"></i>
</template>

<script>
  import {mapActions} from 'vuex'
  export default {
    name: 'itemapPickermsPicker',

    props: {
      rowData: {
        type: Object,
        required: true
      },

      rowIndex: {
        type: Number
      }
    },
    methods: {
      ...mapActions([
        'setCurrentMap'
      ]),
      onClick () {
        this.setCurrentMap(this.rowData.tracker_url)
        console.log(this.rowData.tracker_url)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .item-show {
    &:hover {
        opacity: 0.6;
        cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tables/MapPicker.vue